import { Box, Typography } from "@mui/material";
import React from "react";
import { editBusinessProfileStyles } from "styles/BusinessDirectory/editBusinessProfile.styles";

type EditBusinessHeaderProps = {
  setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
};

const EditBusinessHeader = ({ setIsEditing }: EditBusinessHeaderProps) => {
  return (
    <Box sx={editBusinessProfileStyles.header}>
      <Box>
        <Typography variant="h1" component="h1">
          Edit Profile
        </Typography>
        <Typography sx={editBusinessProfileStyles.requiredText}>
          *Required fields
        </Typography>
      </Box>
      <Box>
        <Typography
          sx={editBusinessProfileStyles.cancelText}
          onClick={() => setIsEditing(false)}
        >
          Cancel
        </Typography>
      </Box>
    </Box>
  );
};

export default EditBusinessHeader;
